<template>
	<div>
	<h6>{{$t('routine_analyses.average_devices')}}</h6>
		<div>
			<div class="row">
			<div class="col s2">{{$t('routine_analyses.order')}}:</div>
			<div class="col s6">
				<select :id="'place_analyses_avg_'+group+'_'+subgroup+'_orderby'" v-model="orderby">
					<option value="number">{{$t('routine_analyses.by_device_number')}}</option>
					<option value="conditions_asc">{{$t('routine_analyses.from_the_lowest_activity')}}</option>
					<option value="conditions_desc">{{$t('routine_analyses.from_the_highest_activity')}}</option>
				</select>
			</div>
			</div>
		<col-chart :devices="devices" :inspections="inspections" :color="color" :orderby='orderby'  mode='avg'/>
	</div>
	</div>
</template>
<script>
export default {
	data: function () {
	    return {
	    	orderby: 'number'
	    }
	},
	props: {
        inspections: Object,
        devices: Object,
        color: String,
        group: String,
		subgroup: String
    },
}
</script>
<style scoped></style>
